import { axios, API, SendRequest } from '@/imports-files/components/jobScorecardComponent/competency';


export class CompetencyComponentService extends SendRequest
{

    constructor()
    {
        super();
    }

    async getCompetencySubCompetencySuggestionData(params)
    {
        let k_this = new CompetencyComponentService();
        let body = {name: params};
        const url =  API.scorecards.COMPETENCY_SUBCOMPETENCY_DATA
        try 
        {
            const result = await axios.get(url,
            {
                params: body,
                headers: k_this.customHeaderJSON()
            },
            k_this.setHeaderJSON(),
            k_this.setCrossDomainTrue(),
            k_this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

}
